import { EnterpriseContactSalesPageTemplate } from "@/templates/enterprise/contact/enterprise-contact-sales-page";

export const EnterpriseContactSalesPage = () => (
    <EnterpriseContactSalesPageTemplate />
);
